import React from 'react'
import ReactDatepicker from 'react-datepicker'
import styled from 'styled-components'

import 'react-datepicker/dist/react-datepicker.css'

import { placeholder, borderColor, inputBackground } from 'styles/colors'
import { title } from 'styles/texts'

const StyledDatepicker = styled(ReactDatepicker)`
  ${title};
  background: ${inputBackground};
  border: 1px solid ${borderColor};
  border-radius: 4px;
  padding: 8px 13px;
  width: 100%;
  -webkit-appearance: none;

  &::placeholder {
    color: ${placeholder};
  }
`

const Datepicker = props => (
  <StyledDatepicker
    dateFormat="DD.MM.YYYY"
    disabledKeyboardNavigation
    {...props}
  />
)

export default Datepicker



// WEBPACK FOOTER //
// ./src/components/form/Datepicker.js